import React from "react"
import PropTypes from "prop-types"
import GoogleMapReact from 'google-map-react';
import googleMapStyle from '../../utils/googleMapStyle'
import loadGoogleMaps from '../../utils/loadGoogleMaps'

class DraggableMap extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      center: {
        lat: 0,
        lng: 0
      },
      zoom: 11,
      lat: 0,
      lng: 0,
      draggable: true,
      loaded: false
    }
  }

  componentDidMount() {
    this.setState({
      center: {
        lat: this.props.lat,
        lng: this.props.lng,
      },
      lat: this.props.lat,
      lng: this.props.lng,
      loaded: true
    })
  }

  componentDidUpdate() {
    if(this.props.lat != this.state.lat) {
      this.setState({
        center: {
          lat: this.props.lat,
          lng: this.props.lng,
        },
        lat: this.props.lat,
        lng: this.props.lng,
        loaded: true
      })
    }
  }


    loadMap = (map, maps) => {
        const cityCircle = new google.maps.Circle({
          strokeColor: "rgb(244, 143, 177)",
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: "rgb(244, 143, 177)",
          fillOpacity: 0.35,
          map,
          center: { lat: this.state.lat, lng: this.state.lng },
          radius: 2000,
          draggable: true
        });

       cityCircle.addListener("dragend", () => {
        this.setState({
          lat: cityCircle.getCenter().lat(),
          lng: cityCircle.getCenter().lng()
        }, () => this.props.updateLatLng(this.state.lat, this.state.lng))
      });
    };


  render() {
    if(!this.state.loaded) {
      return null
    }
    return (
      // Important! Always set the container height explicitly
      <div style={{ height: '100%', width: '100%' }}>
        <GoogleMapReact
          options={{
              styles: googleMapStyle
          }}
          googleMapLoader={loadGoogleMaps}
          defaultCenter={this.state.center}
          center={{lat: this.state.lat, lng: this.state.lng}}
          defaultZoom={this.state.zoom}
          draggable={this.state.draggable}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => this.loadMap(map, maps)}
        >
        </GoogleMapReact>
      </div>
    );
  }

}

export default DraggableMap;
